export default __webpack_public_path__ + "static/media/total-games-icon.6c55bba5.svg";